export default __webpack_public_path__ + "static/media/skovstykket-townhouse-5-rooms-04.55877310.jpg";